module.exports = require("vuetify/lib/components/VTextField");